import { generateTestId } from "@client-shared";

export const setLabelsViewTestId = (identifier: string): string =>
  generateTestId("LabelsView", identifier);
